import { render, staticRenderFns } from "./addOwnerVotingList.vue?vue&type=template&id=61c69f1c&scoped=true"
import script from "./addOwnerVotingList.vue?vue&type=script&lang=js"
export * from "./addOwnerVotingList.vue?vue&type=script&lang=js"
import style0 from "./addOwnerVotingList.vue?vue&type=style&index=0&id=61c69f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c69f1c",
  null
  
)

export default component.exports